import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { camps } from '../../../../../../../models/models.generated';
import { CampsEnumTranslationService } from '../../../../../../../services/camps-enum-translation.service';

@Component({
    selector: 'app-pricing-matrix',
    templateUrl: './pricing-matrix.component.html',
    styleUrls: ['./pricing-matrix.component.scss'],
    standalone: false
})
export class PricingMatrixComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    constructor(public enumTranslation : CampsEnumTranslationService) { 

    }

    ngOnInit(): void {
     
    }

    public get items(): camps.VariantPrice[] {
        return this.form.controls['items'].value as camps.VariantPrice[];
    }

}
